export default {
    path: 'groups',
    component: () => import(/* webpackChunkName: "category-list" */ '@/pages/groups/GroupsList'),
    meta: {title: 'MCN分组'}
}